import type { ServiceType } from '@/pages/home/hooks/useWhatsApp';

interface HighCTAProps {
  onOpenWhatsApp: (service?: ServiceType) => void;
}

export default function HighCTA({ onOpenWhatsApp }: HighCTAProps) {
  return (
    <section className="py-16 md:py-24 bg-accent-950">
      <div className="w-full px-4 md:px-6 lg:px-8 max-w-6xl mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="reveal w-full lg:w-1/2">
            <div className="rounded-2xl overflow-hidden shadow-lg">
              <img
                src="https://readdy.ai/api/search-image?query=Close-up%20of%20premium%20Turkish%20catering%20dishes%20in%20stainless%20steel%20trays%20rich%20colors%20steam%20professional%20food%20photography%20dark%20background&width=800&height=800&seq=cta-food-1&orientation=squarish"
                alt="Premium catering yemekleri"
                className="w-full h-64 md:h-80 lg:h-96 object-cover"
              />
            </div>
          </div>
          <div className="reveal w-full lg:w-1/2 text-center lg:text-left">
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl text-background-50 leading-tight mb-6">
              TOPLU YEMEK İÇİN
              <br />
              FİYAT MI ARAŞTIRIYORSUNUZ?
            </h2>
            <p className="font-body text-background-200 text-base md:text-lg leading-relaxed mb-8">
              Kişi sayınızı bize yazın.
              <br />
              Size en uygun çözümü konuşalım.
            </p>
            <button
              onClick={() => onOpenWhatsApp()}
              className="btn-primary text-base px-10 py-4 mb-4"
            >
              <i className="ri-whatsapp-line text-xl"></i>
              WHATSAPP&apos;TAN FİYAT SOR
            </button>
            <p className="font-label text-background-400 text-sm">
              0542 776 2227
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}